module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C268"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Preface#page_vii"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_1__Intro#page_1"
    }
  }, [_vm._v("1. Introduction: In Search of Freaks")])]), _vm._v(" "), _c('p', {
    staticClass: "C271"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_I__Freak#page_23"
    }
  }, [_vm._v("I. Freak Show: The Institution")])])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_2__From#page_25"
    }
  }, [_vm._v("2. From Tavern to Madison Square Garden: A Chronicle of the Freak Show in America")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__Step#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Step Right Up: The World of Popular Amusement")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__Exoti#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Exotic and Aggrandized: Modes of Presenting Freaks")])]), _vm._v(" "), _c('p', {
    staticClass: "C271"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_II__Prof#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Profiles of Presentation")])])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__The_E#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Exhibition of People We Now Call Mentally Retarded")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__Illus#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Illusions of Grandeur")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7__Canni#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Cannibals and Savages")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8__Respe#page_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Respectable Freaks")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_9__Self_#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Self-Made Freaks")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_10__Conc#page_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Conclusion: Freak Encounter")])]), _vm._v(" "), _c('p', {
    staticClass: "C271"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_List_of#page_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Notes#page_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Referenc#page_301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C270"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index#page_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e1eaf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Contents.vue
// module id = 63
// module chunks = 0